import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BoxExpand, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { CompanyProfileInfo } from 'src/pages/settings/components/company-profile/components/company-profile-info';
import { DEFAULT_COMPANY_TO_DELETE } from 'src/pages/settings/components/company-profile/company-profile.constants';
import { DeleteSubsidiaryCompany } from 'src/pages/settings/components/company-profile/components/delete-subsidiary-company';
import { useGetSubsidiaryCompaniesByParent } from 'src/hooks/companies/get-subsidiary-companies.hook';

import CompanyActionButtons from './company-action-buttons.component';

const CompanyExpandedList = ({ company }: { company: any }) => {
  const { t } = useTranslation(['common', 'settings']);

  const [companyToDelete, setCompanyToDelete] = useState(DEFAULT_COMPANY_TO_DELETE);

  const { companies } = useGetSubsidiaryCompaniesByParent(company._id);

  return (
    <div>
      {companyToDelete._id && <DeleteSubsidiaryCompany companyToDelete={companyToDelete} />}
      <BoxExpand
        title={`${t(`settings:company.labels.subsidiaryCompany`)}: ${company.name}`}
        titleFontSize={TYPOGRAPHY_SIZE.medium}
        separator
        buttons={
          <CompanyActionButtons
            company={company}
            companies={companies}
            setCompanyToDelete={setCompanyToDelete}
          />
        }
      >
        <CompanyProfileInfo company={company} />
        {companies?.map((item: any) => (
          <CompanyExpandedList key={item._id} company={item} />
        ))}
      </BoxExpand>
    </div>
  );
};

export default CompanyExpandedList;
